import React, { ReactNode } from "react";
import { getLocalStorageLoginToken } from "src/utils/localStorageWorker";
import Layout from "../PageLayout";
import useEnsureUserIsLoggedIn from "./useEnsureUserIsLoggedIn";

type Props = {
  children: ReactNode;
};

const DashboardLayout = ({ children }: Props) => {
  useEnsureUserIsLoggedIn();

  if (!getLocalStorageLoginToken()) {
    return null;
  }

  return <Layout>{children}</Layout>;
};

export default DashboardLayout;
